import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios/requestInfo";
import { api } from "../../resources/api";

import {INews} from "./types";

export const fetchGetNews = createAsyncThunk<INews[], number>(
  "getNews/fetchGetNews",
  async (data) => {
    try {
      const response = await axiosInstance.get(api.news.GET_NEWS(data));
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }
);

